import { TermosCondicoesModal } from './TermosCondicoesModal';

// `simples` tira a caixa cinza em volta — usado onde o aceite já está
// dentro de um card (checkout de evento).
export default function AceiteTermosCondicoes({
  aceito,
  onChange,
  simples = false,
}) {
  return (
    <div
      className={
        simples
          ? 'text-[11px] leading-relaxed text-[#4b5568] lg:text-xs'
          : 'p-4 bg-slate-50 border border-slate-200 rounded-2xl space-y-3 text-xs text-slate-500 leading-relaxed'
      }
    >
      <label
        className={`flex items-start cursor-pointer ${simples ? 'gap-2.5' : 'gap-3'}`}
      >
        <input
          type="checkbox"
          checked={aceito}
          onChange={(e) => onChange(e.target.checked)}
          className={
            simples
              ? 'mt-0.5 w-[18px] h-[18px] lg:w-4 lg:h-4 accent-[#ff2368] cursor-pointer flex-shrink-0'
              : 'mt-0.5 w-4 h-4 accent-[#ff2d6c] cursor-pointer flex-shrink-0'
          }
        />
        <span className={simples ? '' : 'font-semibold text-slate-700'}>
          Li e concordo com os <TermosCondicoesModal /> do Lily Book Club e
          autorizo o uso de meus dados conforme descrito (apenas para uso
          interno, em conformidade com a LGPD).
        </span>
      </label>
    </div>
  );
}
